var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756969261694,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1809,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.624 800H96a64 64 0 0 1-64-64V288a64 64 0 0 1 64-64h339.136l-81.056-81.088a32 32 0 0 1 45.248-45.248l133.984 133.984a31.904 31.904 0 0 1 11.136 24.32 31.904 31.904 0 0 1-11.136 24.384l-133.984 133.984a32 32 0 1 1-45.248-45.248L435.136 288H128a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h306.624l-81.088-81.088a32 32 0 0 1 45.248-45.248l133.984 133.984a31.904 31.904 0 0 1 11.136 24.32 31.904 31.904 0 0 1-11.136 24.384l-133.984 133.984a32 32 0 1 1-45.248-45.248L434.624 800zM672 64h256a64 64 0 0 1 64 64v256a64 64 0 0 1-64 64h-256a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m128 512a192 192 0 1 1 0 384 192 192 0 0 1 0-384zM704 128a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32h-192z m96 512a128 128 0 1 0 0 256 128 128 0 0 0 0-256z",
    fill: "#ffffff",
    "p-id": 1810
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.aef263ee33a23364731362ca8aebdfcd.svg";
export { ForwardRef as ReactComponent };